import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import {
  Route,
  Switch,
  withRouter,
  RouteComponentProps,
} from 'react-router-dom';
import SearchContainer from '../../containers/search/searchContainer';
import MainContainer from '../../containers/main';

const AppContainter = styled.div`
  height: 100%;
  width: 100%;
`;

interface AppProps extends RouteComponentProps {}

class App extends React.PureComponent<AppProps, any> {
  render() {
    return (
      <AppContainter>
        <Switch>
          <Route exact path="/" component={MainContainer} />
          <Route path="/search" component={SearchContainer} />
          <Route path="*" component={MainContainer} />
        </Switch>
      </AppContainter>
    );
  }
}

export default withRouter(App);
